//TODO Reading event

class NotificationPwa {

    authorizationFlagDefault = 'N';
    availableFlagValues = ['Y', 'N'];

    CURRENT_USER_ID = 'USER_ID';
    IS_DENIED_PUSH = 'decline-push';
    currentUserId = BX.message(this.CURRENT_USER_ID);

    constructor(authorizationFlag = this.authorizationFlagDefault) {
        try {
            this.authorizationFlag = authorizationFlag;

            if (!this.availableFlagValues.includes(this.authorizationFlag)) {
                new TypeError('Invalid value of authorization flag');
            }

            if (this.isAvailabilityDependencies() === false) {
                return false;
            }


            if ("Notification" in window) {
                if (!this.isStandalone()) {
                    console.info('Not full-screen mode');
                    return;
                }

                if (!this.currentUserId) {
                    this.removeSubscription();
                    localStorage.removeItem(this.IS_DENIED_PUSH);
                    return;
                }

                this.checkSubscription();
            }

        } catch (e) {
            console.error(e);
            return false;
        }
    }

    isAvailabilityDependencies() {
        if (!('serviceWorker' in navigator)) {
            console.info("Service Worker isn't supported on this browser.");
            return false;
        }

        if (!('PushManager' in window)) {
            console.info("Push isn't supported on this browser.");
            return false;
        }

        return true;
    }

    isStandalone() {
        return window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
    }

    async checkSubscription() {
        try {
            const serviceWorkerRegistration = await navigator.serviceWorker.ready;
            const subscription = await serviceWorkerRegistration.pushManager.getSubscription();
            const isDeniedUserPush = localStorage.getItem(this.IS_DENIED_PUSH);

            if (!subscription && !isDeniedUserPush) {
                this.shopPopupSubscription();
                return;
            }

        } catch (error) {
            console.error('Error checking subscription:', error);
        }
    }

    async removeSubscription() {
        try {
            const serviceWorkerRegistration = await navigator.serviceWorker.ready;
            const subscription = await serviceWorkerRegistration.pushManager.getSubscription();

            if (subscription) {
                subscription.unsubscribe();
            }
        } catch (error) {
            console.log(error);
        }
    }

    // TODO The method must be called in the child class after the user agrees to the subscription.
    async handlePushButtonClick() {
        try {
            const permissionGranted = await this.askForNotificationPermission();

            if (!permissionGranted) {
                console.error('No notification permission granted!');
                return;
            }

            const vapidPublicKey = await this.getPublicKey();

            if (vapidPublicKey) {
                await this.configurePushSubscription(vapidPublicKey);
            }

        } catch (error) {
            console.error('Error in push button handling:', error);
        }
    }

    // TODO Request permission for notifications
    async askForNotificationPermission() {
        const permission = await Notification.requestPermission();
        return permission === 'granted';
    }

    // TODO Get public key VAPID
    async getPublicKey() {
        try {
            return (await BX.ajax.runAction('sotbit:notification.PWA.createKey')).data.publicKey;
        } catch (error) {
            console.log('Error fetching VAPID key:', error);
        }
    }

    // TODO Setting up a subscription to push notifications
    async configurePushSubscription(vapidPublicKey) {
        let registration = await navigator.serviceWorker.ready;

        navigator.serviceWorker.ready
            .then((serverWorkerRegistration) => {
                registration = serverWorkerRegistration;
                return serverWorkerRegistration.pushManager.getSubscription();
            })
            .then((subscription) => {
                if (subscription === null) {
                    return registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: this.urlB64ToUint8Array(vapidPublicKey)
                    });
                }
            })
            .then(async (newSubscription) => {
                if (newSubscription) {
                    await this.sendSubscriptionToServer(newSubscription);
                }
            });
    }

    // TODO Convert base64 string to Uint8Array
    urlB64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }

        return outputArray;
    }

    async sendSubscriptionToServer(subscription) {
        try {
            const jsonKey = subscription.toJSON();
            const response = await BX.ajax.runAction('sotbit:notification.PWA.saveSubscription', {
                'data': {jsonKey}
            });
        } catch (error) {
            console.error('Error sending subscription to server:', error);
        }
    }

    saveNotificationDenied() {
        localStorage.setItem(this.IS_DENIED_PUSH, 'Y');
    }
}
